// Morgan's Quarterly MA Studio (Pepper Potts' Report Studio 2.0): independent copy of the standard MA report call in batch13Api.
import { postForFile } from './batch3Api';

export interface MaReportV2Summary {
  company: string;
  prior_source: string | null;
}

export interface MaReportV2Input {
  pnl: File;
  bs: File | null;
  coa: File;
  logo: File | null;
  reportTitle: string;
  clientName: string;
  subClientName: string;
  customNotes: string;
  makePptx: boolean;
  lastYearDate: string;
}

export function generateMaReportV2(input: MaReportV2Input) {
  const form = new FormData();
  form.append('pnl_file', input.pnl);
  form.append('coa_file', input.coa);
  if (input.bs) form.append('bs_file', input.bs);
  if (input.logo) form.append('logo_file', input.logo);
  form.append(
    'options',
    JSON.stringify({
      report_title: input.reportTitle,
      client_name: input.clientName,
      sub_client_name: input.subClientName,
      custom_notes: input.customNotes,
      make_pptx: input.makePptx,
      last_year_date: input.lastYearDate || null,
    })
  );
  return postForFile<MaReportV2Summary>('/ma-report-v2/generate', form, 'MA_report_v2.pdf', 'Report generation failed');
}
